<template>
  <!--返回顶部-->
  <div class="goTopBox">
    <p>For more information please contact us</p>
    <div class="goTopBtn"
         @click="goTopBtn">Back to top</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
     timer:''
    }
  },
  methods: {
    goTopBtn () {
      const that = this
      that.timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(that.timer)
        }
      }, 16)
    },
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },

}
</script>



// WEBPACK FOOTER //
// src/components/goTop.vue